export default "__VITE_ASSET__B4cZSK$G__"